import { MediaStreamKind, Slot, SlotType } from '@yandex-video-platform/goloom-sdk';
import cn from 'classnames';

import css from '../styles.css';

export const getSlotsClassNames = ({
    slots,
    videoStatus,
    canZoomOut,
}: {
    slots: Slot[];
    videoStatus: boolean;
    canZoomOut: boolean;
}) => {
    return slots.map((slot) => {
        if (slot.type === SlotType.SELF_VIEW) {
            return cn(css.selfView, {
                [css.itemDevices]: videoStatus,
            });
        }

        const isDisplay = slot.mediaStreamKind === MediaStreamKind.DISPLAY;

        return cn({
            [css.itemDisplay]: isDisplay,
            [css.itemDisplayGrab]: isDisplay && canZoomOut,
            [css.itemDevices]: slot.mediaStreamKind === MediaStreamKind.DEVICES,
        });
    });
};
